import { FeatureCollection, MultiPolygon } from 'geojson'

export const StationsGeojson: FeatureCollection<MultiPolygon> = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      properties: {},
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-18.9, 29.2],
              [-18.2, 29.8],
              [-17.3, 29.7],
              [-16.9, 29.4],
              [-16.5, 29.6],
              [-15.9, 29.5],
              [-15.4, 29.3],
              [-15.3, 29.1],
              [-14.9, 29.1],
              [-14.4, 29.8],
              [-13.7, 30.3],
              [-13.1, 30.2],
              [-12.8, 30],
              [-12.4, 29.4],
              [-12.6, 28.6],
              [-13.3, 27.5],
              [-14.2, 27.1],
              [-14.7, 27.1],
              [-15.2, 26.8],
              [-15.9, 26.8],
              [-16.3, 27.1],
              [-16.4, 27],
              [-17.2, 27],
              [-17.8, 26.7],
              [-18.7, 26.8],
              [-19.1, 27.3],
              [-19.1, 27.9],
              [-18.9, 28.4],
              [-18.9, 29.2]
            ]
          ],
          [
            [
              [-7.9, 44.8],
              [-6.9, 44.6],
              [-5.8, 44.7],
              [-4.5, 44.4],
              [-3.6, 44.5],
              [-2.2, 44.3],
              [-1.7, 44.4],
              [0.1, 43.7],
              [0.9, 43.8],
              [2, 43.5],
              [3.3, 43.4],
              [4, 43.1],
              [4.3, 42.6],
              [4.2, 41.8],
              [3.8, 41.1],
              [4.4, 41],
              [4.9, 40.8],
              [5.3, 40.2],
              [5.3, 39.6],
              [5, 39.1],
              [4.5, 38.8],
              [4.1, 38.8],
              [3.4, 38.2],
              [3.1, 38.1],
              [2.5, 38.2],
              [2.3, 37.9],
              [1.8, 37.7],
              [1.1, 37.7],
              [0.7, 37.9],
              [0.5, 37.8],
              [0.3, 37.6],
              [-0.1, 36.8],
              [-1, 36.6],
              [-1.4, 36],
              [-2, 35.7],
              [-2, 35],
              [-2.3, 34.5],
              [-2.6, 34.3],
              [-3.3, 34.3],
              [-3.6, 34.5],
              [-3.9, 35],
              [-3.9, 35.7],
              [-4.3, 35.6],
              [-4.8, 35],
              [-5.4, 34.9],
              [-6.5, 35.3],
              [-7.3, 36.2],
              [-7.8, 36.3],
              [-8.2, 36.6],
              [-8.5, 37.5],
              [-8.2, 38.9],
              [-8.5, 39.8],
              [-7.9, 40.8],
              [-9.1, 40.9],
              [-9.7, 41.3],
              [-10.3, 42.8],
              [-10.3, 43.2],
              [-9.9, 43.9],
              [-7.9, 44.8]
            ]
          ]
        ]
      }
    }
  ]
}
